// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as HelpComponent} from './Help.svg';

import Icon, { TIconProps } from '../Icon';

export const IconHelp = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <HelpComponent/>
  </Icon>
));
